import React, { useContext, useState, useEffect, useReducer } from 'react';
import { Link, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import Dropzone from 'react-dropzone';
import Select from 'react-select';
import { AuthContext } from '../context/AuthContext';
import useSkills from '../hooks/useSkills';

import { ModalContainer, ModalHeader } from '../components/Atoms/Modal';
import searchFile from '../helpers/searchFile';
import Button from '../components/Buttons';
import Layout from '../components/Layout';
import { Pill } from '../components/Atoms/Form';

import { SearchContext } from '../context/SearchContext';
import { UIContext } from '../context/UIContext';

const Profile = (props) => {
    const { toggleMobileMenu, toggleStudioMenu } = useContext(UIContext);
    const { user, updateUser, deleteUser, loading } = useContext(AuthContext);
    const { jobOptions, setJobOptions, jobList, branchList } = useContext(SearchContext);
    let { skillsData, getRecommendedSkills, recommendedSkills, removeRecommendedSkill, removeFromAllSkills, addToAllSkills } = useSkills();
    const [stateUser, setStateUser] = useState('');

    const [deleteUserReq, setDeleteUserReq] = useState(true);

    useEffect(() => {
        if (user !== null) {
            setStateUser(user);
        }
        setDeleteUserReq(false);
        toggleMobileMenu(false);
        toggleStudioMenu(false);
    }, [user]);

    const changeInputField = (e) => {
        let updateUser = { ...stateUser };
        updateUser[e.target.name] = e.target.value;
        setStateUser(updateUser);
    };

    const changeSelectField = async (e, type) => {
        if (type === 'branch') {
            const filterJobTitles = e.length !== 0 && jobList.filter((job) => job.branch === e._id);
            setJobOptions(filterJobTitles);
            let updateUser = { ...stateUser };
            updateUser.preferences[type] = e;
            updateUser.jobMailEnabled = true;
            setStateUser(updateUser);
        }

        if (type === 'job') {
            let updateUser = { ...stateUser };
            updateUser.preferences[type] = e;
            setJobOptions(jobOptions);
            setStateUser(updateUser);
        }

        if (type === 'workLevel') {
            let updateUser = { ...stateUser };
            updateUser.preferences[type] = e;
            setStateUser(updateUser);
        }
    };

    const changeSwitch = (type) => {
        let updateUser = { ...stateUser };
        updateUser[type] = !stateUser[type];
        setStateUser(updateUser);
    };

    const addSkillToUser = (skill) => {
        setStateUser({ ...stateUser, skills: [...stateUser.skills, skill] });
        removeFromAllSkills(skill._id);
        removeRecommendedSkill(skill._id);
    };

    const removeSkill = (skill) => {
        let skills_arr = stateUser.skills.filter((item) => item.value !== skill.value);
        setStateUser({ ...stateUser, skills: skills_arr });
        addToAllSkills(skill);
    };

    return (
        <Layout environment="people" title="Profile" hasSearch hideSearchModal>
            <div className="flex justify-start items-start bg-indigo-700 h-64" aria-hidden="true">
                <header className="max-w-7xl w-full mx-auto  relative py-10">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h1 className="text-3xl font-bold text-white">Profile</h1>
                    </div>
                </header>
            </div>

            <main className="relative -mt-32">
                <div className="max-w-screen-xl mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8">
                    <div className="bg-white rounded-lg shadow overflow-hidden">
                        <div className="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
                            <aside className="py-6 relative h-full lg:col-span-3">
                                <nav>
                                    <Link
                                        to="general-info"
                                        activeclassName="bg-teal-50 border-l-4 border-indigo-500 text-teal-700 hover:bg-teal-50 hover:text-teal-700"
                                        className="group mt-1 border-l-4 border-transparent px-6 py-2 flex items-center text-sm font-medium text-gray-900 cursor-pointer hover:bg-gray-50 hover:text-gray-900"
                                        spy={true}
                                        smooth={true}
                                        offset={0}
                                        duration={500}
                                    >
                                        <svg
                                            className="flex-shrink-0 -ml-1 mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                            />
                                        </svg>
                                        <span className="truncate">General info</span>
                                    </Link>
                                    <Link
                                        to="job-mail"
                                        activeclassName="bg-teal-50 border-l-4 border-indigo-500 text-teal-700 hover:bg-teal-50 hover:text-teal-700"
                                        className="group mt-1 border-l-4 border-transparent px-6 py-2 flex items-center text-sm font-medium text-gray-900 cursor-pointer hover:bg-gray-50 hover:text-gray-900"
                                        spy={true}
                                        smooth={true}
                                        offset={0}
                                        duration={500}
                                    >
                                        <svg
                                            className="flex-shrink-0 -ml-1 mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                                            />
                                        </svg>
                                        <span className="truncate">Job preferences</span>
                                    </Link>
                                    <Link
                                        to="settings"
                                        activeclassName="bg-teal-50 border-l-4 border-indigo-500 text-teal-700 hover:bg-teal-50 hover:text-teal-700"
                                        className="group mt-1 border-l-4 border-transparent px-6 py-2 flex items-center text-sm font-medium text-gray-900 cursor-pointer hover:bg-gray-50 hover:text-gray-900"
                                        spy={true}
                                        smooth={true}
                                        offset={0}
                                        duration={500}
                                    >
                                        <svg
                                            className="flex-shrink-0 -ml-1 mr-3 h-6 w-6 text-gray-400 group-hover:text-gray-500"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            aria-hidden="true"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                            />
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                        <span className="truncate">Settings</span>
                                    </Link>
                                </nav>
                            </aside>

                            <form onSubmit={(e) => updateUser(stateUser)} className="divide-y divide-gray-200 lg:col-span-9">
                                {/* ------------GENERAL INFO  ------------*/}
                                <Element name="general-info">
                                    <div className="py-6 px-4 sm:p-6 lg:pb-8">
                                        <div>
                                            <h2 className="text-lg leading-6 font-medium text-gray-900">General info</h2>
                                            <p className="mt-1 text-sm text-gray-500">Fill in your personal info here.</p>
                                        </div>

                                        <div className="mt-6 grid grid-cols-12 gap-6">
                                            <div className="col-span-12 sm:col-span-6">
                                                <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">
                                                    First name
                                                </label>
                                                <input
                                                    data-cy="input-firstName"
                                                    name="firstName"
                                                    onChange={(e) => changeInputField(e)}
                                                    defaultValue={stateUser.firstName}
                                                    type="text"
                                                    id="first_name"
                                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                                                />
                                            </div>
                                            <div className="col-span-12 sm:col-span-6">
                                                <label htmlFor="first_name" className="block text-sm font-medium text-gray-700">
                                                    Last name
                                                </label>
                                                <input
                                                    data-cy="input-lastName"
                                                    name="lastName"
                                                    onChange={(e) => changeInputField(e)}
                                                    defaultValue={stateUser.lastName}
                                                    type="text"
                                                    id="first_name"
                                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                                                />
                                            </div>

                                            <div className="col-span-12 sm:col-span-7">
                                                <label htmlFor="last_name" className="block text-sm font-medium text-gray-700">
                                                    Email
                                                </label>
                                                <input
                                                    data-cy="input-email"
                                                    name="email"
                                                    onChange={(e) => changeInputField(e)}
                                                    defaultValue={stateUser.email}
                                                    type="email"
                                                    id="email"
                                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 sm:text-sm"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Element>

                                {/* ------------ JOB MAIL ------------*/}
                                <Element name="job-mail">
                                    <div className="py-6 px-4 sm:p-6 lg:pb-8">
                                        <div>
                                            <h2 className="text-lg leading-6 font-medium text-gray-900">Job preferences</h2>
                                            <p className="mt-1 text-sm text-gray-500">
                                                Fill out your job preferences and receive relevant job matches every week.
                                            </p>
                                        </div>

                                        <div className="mt-6 grid grid-cols-12 gap-6">
                                            <div className="col-span-12 sm:col-span-4">
                                                <label htmlFor="branch" className="block text-sm font-medium text-gray-700">
                                                    Branch
                                                </label>
                                                <Select
                                                    onChange={(e) => changeSelectField(e, 'branch')}
                                                    defaultValue={stateUser.preferences !== undefined && stateUser.preferences.branch}
                                                    value={stateUser.preferences !== undefined && stateUser.preferences.branch}
                                                    options={branchList && branchList}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.name}
                                                    name="branch"
                                                />
                                            </div>

                                            <div className="col-span-12 sm:col-span-4">
                                                <label htmlFor="job" className="block text-sm font-medium text-gray-700">
                                                    Job title
                                                </label>
                                                <Select
                                                    onChange={(e) => changeSelectField(e, 'job')}
                                                    defaultValue={stateUser.preferences !== undefined && stateUser.preferences.job}
                                                    value={stateUser.preferences !== undefined && stateUser.preferences.job}
                                                    options={jobOptions.length ? jobOptions : jobList}
                                                    getOptionLabel={(option) => option.humanReadable}
                                                    getOptionValue={(option) => option.humanReadable}
                                                    name="job"
                                                />
                                            </div>
                                            <div className="col-span-12 sm:col-span-4">
                                                <label htmlFor="workLevel" className="block text-sm font-medium text-gray-700">
                                                    Work level
                                                </label>
                                                <Select
                                                    onChange={(e) => changeSelectField(e, 'workLevel')}
                                                    defaultValue={stateUser.preferences !== undefined && stateUser.preferences.workLevel}
                                                    value={stateUser.preferences !== undefined && stateUser.preferences.workLevel}
                                                    options={searchFile && searchFile.workLevel}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.name}
                                                    name="workLevel"
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-4">
                                            <ul className="mt-2 divide-y divide-gray-200">
                                                <li className="py-4 flex items-center justify-between">
                                                    <div className="flex flex-col">
                                                        <label htmlFor="company" className="block text-base font-medium text-gray-700">
                                                            Enable job mail
                                                        </label>
                                                        <p id="privacy-option-description-1" className="text-sm text-gray-500">
                                                            Receive all relevant jobs by email. No spam and only when we found a real match.
                                                        </p>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        onClick={() => changeSwitch('jobMailEnabled')}
                                                        aria-pressed="true"
                                                        aria-labelledby="timezone-option-label"
                                                        className={`${
                                                            user != null && stateUser.jobMailEnabled ? 'bg-green-300' : 'bg-gray-200'
                                                        } relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:ml-auto`}
                                                    >
                                                        <span className="sr-only">Use setting</span>
                                                        <span
                                                            aria-hidden="true"
                                                            className={`${
                                                                user != null && stateUser.jobMailEnabled ? 'translate-x-5' : 'translate-x-0'
                                                            }  inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}
                                                        ></span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Element>
                                {/* ------------ SKILLS ------------*/}
                                <Element name="skills">
                                    <div className="py-6 px-4 sm:p-6 lg:pb-8">
                                        <div className="flex flex-col sm:flex-row items-start justify-between">
                                            <div className="">
                                                <h2 className="text-lg leading-6 font-medium text-gray-900">Skills set</h2>
                                                <p className="mt-1 text-sm text-gray-500">Pick your skills to find more relevant jobs.</p>
                                            </div>
                                            {stateUser && stateUser.preferences.job.humanReadable && (
                                                <div className="mt-4 sm:mt-0">
                                                    <Button
                                                        type="button"
                                                        onClick={() => getRecommendedSkills(stateUser.preferences.job._id, stateUser.skills)}
                                                        text="Load recommended skills"
                                                        theme="btn-mini btn-outline"
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        {/* EMPTY Skills state */}
                                        {stateUser.skills !== undefined && stateUser.skills.length === 0 && (
                                            <div className="mt-6 flex flex-wrap gap-2 max-w-lg py-8 px-4 bg-gray-100 rounded-lg">
                                                <h3 className="text-base text-gray-600">There are no skills yet.</h3>
                                                <p className="text-sm text-gray-600 ">
                                                    To add skills ask for recommended skills or select skills yourself below.
                                                </p>
                                            </div>
                                        )}
                                        {stateUser.skills !== undefined && stateUser.skills.length !== 0 && (
                                            <div className="mt-6 flex flex-wrap gap-2 max-w-lg py-8 px-4 bg-gray-100 rounded-lg">
                                                {stateUser.skills !== undefined &&
                                                    stateUser.skills.map((x) => (
                                                        <Pill
                                                            key={x.value}
                                                            onClick={() => addSkillToUser(x)}
                                                            onRemove={() => removeSkill(x)}
                                                            selected={stateUser.skills.filter((e) => e.value === x.value).length > 0}
                                                        >
                                                            {x.label}
                                                        </Pill>
                                                    ))}
                                                {recommendedSkills &&
                                                    recommendedSkills.map((x) => (
                                                        <Pill
                                                            key={x.value}
                                                            onClick={() => addSkillToUser(x)}
                                                            onRemove={() => removeSkill(x)}
                                                            selected={stateUser.skills.filter((e) => e.value === x.value).length > 0}
                                                        >
                                                            {x.label}
                                                        </Pill>
                                                    ))}
                                            </div>
                                        )}

                                        <div className="max-w-xs mt-4 space-y-2">
                                            <label>Add more skills</label>
                                            <Select label="Add more skills" options={skillsData} onChange={(v) => addSkillToUser(v)} />
                                        </div>
                                    </div>
                                </Element>
                                {/* ------------ SETTINGS ------------*/}
                                <Element name="settings">
                                    <div className="py-6 px-4 sm:p-6 lg:pb-8">
                                        <div>
                                            <h2 className="text-lg leading-6 font-medium text-gray-900">Settings</h2>
                                            <p className="mt-1 text-sm text-gray-500"></p>
                                        </div>

                                        <div className="mt-6">
                                            <ul className="mt-2 divide-y divide-gray-200">
                                                <li className="py-4 flex flex-col sm:flex-row items-start sm:justify-between">
                                                    <div className="flex flex-col">
                                                        <label htmlFor="company" className="block text-base font-medium text-gray-700">
                                                            Delete account
                                                        </label>
                                                        <p id="privacy-option-description-1" className="text-sm text-gray-500">
                                                            Deleting your account will remove everything in our systems
                                                        </p>
                                                    </div>
                                                    <div className="sm:mt-0 mt-4">
                                                        <Button
                                                            data_cy="button-req-delete-user"
                                                            type="button"
                                                            onClick={() => setDeleteUserReq(true)}
                                                            text="Delete account"
                                                            theme="btn-mini btn-black"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Element>
                                <div className="mt-4 py-4 px-4 flex justify-end sm:px-6">
                                    <div className="">
                                        <Button
                                            type="button"
                                            loading={loading}
                                            text="Save profile"
                                            theme="btn-mini btn-purple"
                                            onClick={() => updateUser(stateUser)}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
            {deleteUserReq && (
                <ModalContainer hideCloseBtn modalState={deleteUserReq} modalWidth="max-w-3xl">
                    <ModalHeader
                        title={`We are sad to see you leave`}
                        description="All your provided information will be deleted from our servers. Deleting your account is irreversible."
                    />
                    <div className="flex flex-col justify-center items-center mt-5 space-y-5">
                        <div className="flex w-full max-w-sm gap-2">
                            <Button
                                data_cy="button-confirm-delete-user"
                                loading={loading}
                                onClick={() => deleteUser()}
                                theme="btn btn-black"
                                text="Delete account"
                            />
                            <Button onClick={() => setDeleteUserReq(false)} theme="btn btn-outline" text="Cancel" />
                        </div>
                    </div>
                </ModalContainer>
            )}
        </Layout>
    );
};
export default Profile;
